module.exports = __webpack_public_path__ + "static/media/image 42.28902041.png";